import { render, staticRenderFns } from "./hbp-1.vue?vue&type=template&id=bd47344e&scoped=true"
import script from "./hbp-1.vue?vue&type=script&lang=js"
export * from "./hbp-1.vue?vue&type=script&lang=js"
import style0 from "./hbp-1.vue?vue&type=style&index=0&id=bd47344e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd47344e",
  null
  
)

export default component.exports